import React, { useState } from 'react';
import { Row, Col, Form, Label, Input } from 'reactstrap';
import FormInput from '../../common/FormInput';
import AssociateManufacturerModal, { ManufacturerData } from '../../modals/brand/AssociateManufacturerModal';
import { useFormSection } from '../../../context/ProductDetailContext';

const BrandDetail: React.FC = () => {
  // Use form context instead of props
  const { watch, setValue, getError } = useFormSection('productProfile');
  
  const [isManufacturerModalOpen, setIsManufacturerModalOpen] = useState(false);

  const handleOpenManufacturerModal = () => setIsManufacturerModalOpen(true);
  const handleCloseManufacturerModal = () => setIsManufacturerModalOpen(false);
  const handleSelectManufacturer = (manufacturer: ManufacturerData) => {
    setValue('manufacturerName', manufacturer.name);
    // You might want to set manufacturerId if available in the manufacturer data
    // setValue('manufacturerId', manufacturer.id);
    setIsManufacturerModalOpen(false);
  };

  // Get current values from form context
  const manufacturerName = watch('manufacturerName') || '';
  const manuProductCode = watch('manuProductCode') || '';

  return (
    <fieldset className="border rounded p-2">
      <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>Brand</legend>
      <Form>
        <Row>
          <Col md={6}>
            <FormInput
              label="Brand"
              type="text"
              className="form-control"
              id="manufacturerName"
              value={manufacturerName}
              onChange={(value: string) => setValue('manufacturerName', value)}
              readOnly
              hasSearchButton
              onSearchClick={handleOpenManufacturerModal}
            />
            {/* Display validation error if any */}
            {getError('manufacturerName') && (
              <div className="text-danger small mt-1">
                {getError('manufacturerName')?.message}
              </div>
            )}
          </Col>
          <Col md={6}>
            <FormInput
              label="B. Prod Code"
              type="text"
              className="form-control"
              id="manuProductCode"
              value={manuProductCode}
              onChange={(value: string) => setValue('manuProductCode', value)}
            />
            {/* Display validation error if any */}
            {getError('manuProductCode') && (
              <div className="text-danger small mt-1">
                {getError('manuProductCode')?.message}
              </div>
            )}
          </Col>
        </Row>
      </Form>
      <AssociateManufacturerModal
        isOpen={isManufacturerModalOpen}
        onClose={handleCloseManufacturerModal}
        onSelect={handleSelectManufacturer}
      />
    </fieldset>
  );
};

export default BrandDetail; 